import { Controller } from '@hotwired/stimulus'
import lottie from 'lottie-web'

export default class LottieController extends Controller {
  static targets = ['container']
  static values = {
    jsonPath: { type: String }
  }

  connect () {
    this.animation = lottie.loadAnimation({
      container: this.containerTarget,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: this.jsonPathValue,
      rendererSettings: {
        className: 'lottie__container'
      }
    })
  }

  disconnect () {
    if (this.animation) {
      this.animation.destroy()
    }
  }
}
